import { createV3Queries } from "@query/utils/createV3Queries";
import { payStatementsApi } from "@api";

export const queriesPayStatements = createV3Queries(
  "payStatementsApi",
  payStatementsApi
);
